import { FormWithUnsavedChangesPrompt } from '@components/generic-modals';
import { Sidebar } from '@components/sidebar';
import { Stack } from '@components/stack';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import {
  ActionFooter,
  ActionHeader,
  ActionSidebarLoading,
  DescriptionFormField,
  SidebarProps,
  createActionForm,
  useCreateActionFormStore,
} from 'ui/journey-builder/node-types/common';

type PlaceholderData = {
  description: string;
};

const ACTION_TYPE = ACTION_TYPES.placeholder;
const Form = createActionForm<PlaceholderData>();

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { data, isLoading } = useJourneyAction(journeyActionId);
  const formStore = useCreateActionFormStore();
  const isDirty = formStore.useIsDirty();

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const handleSave = async (data: PlaceholderData) => {
    await editMutation.mutateAsync({
      description: data.description,
      isAutomatic: true,
      action: ACTION_TYPE,
    });
  };

  if (isLoading || !data) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }

  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <FormWithUnsavedChangesPrompt store={formStore} onSubmit={handleSave}>
          <Stack space={6}>
            <Stack space={4}>
              <DescriptionFormField defaultValue={data.description} isAutoFocused />
            </Stack>
            <ActionFooter
              action={data}
              isDisabled={!isDirty || editMutation.isLoading}
              form={Form}
            />
          </Stack>
        </FormWithUnsavedChangesPrompt>
      </Sidebar.Content>
    </Sidebar>
  );
};
